import { render, staticRenderFns } from "./QLeadCounts.vue?vue&type=template&id=db5e49dc&"
import script from "./QLeadCounts.vue?vue&type=script&lang=js&"
export * from "./QLeadCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports